<template>
  <div id="app">
    <keep-alive>
      <router-view  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
}
</script>

<style>

#app {
  position: relative;
  background: url(./assets/bg.jpg) no-repeat bottom/cover;
  /*font-family: SimHei;*/
  /*font-family: SimSun;*/
}
</style>
